import { api } from 'settings.js'

function pqFetch(req, options = {}) {
	// Support relative URLs when address is empty (for dev server proxy).
	// This  only comes into play for merlin coin dev'ing 
	const path = api.address
		? `http${ api.https ? 's' : ''}://${ api.address }${ api.path }${ req }`
		: `${ api.path }${ req }`

	return fetch(path, options).then(res => {

		if (res.ok === false) {
			// Throw an error: The fetch completed successfully, but we got an HTTP error
			// so we will translate this into a catch-able JavaScript Error
			// Include a clone of the response for further processing of the error

			const error = new Error(`HTTP ERROR: ${ res.status } ${ res.statusText }`)
			error.response = res.clone()
			throw error
		}

		return res
	})
}

// Content-Type / Accept values

pqFetch.FORM_URLENCODED = 'application/x-www-form-urlencoded'
pqFetch.FORM_MULTIPART = 'multipart/form-data'
pqFetch.JSON = 'application/json'

// URL-Encode an Object

pqFetch.query = function (o) {
	return Object.keys(o).filter(k => o[k] !== null).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(o[k])}`).join('&')
}

// URL-Decode a string

pqFetch.parse = function (s) {
	return s.substring(1).split('&').reduce((o, p) => {
		const [key, value] = p.split('=')
		o[decodeURIComponent(key)] = decodeURIComponent(value)
		return o
	}, {})
}

// Add credentials to request headers
pqFetch.setCredentials = function (options, username, password) {
	if (!options.headers) {
		options.headers = {}
	}
	options.headers['username'] = username
	options.headers['password'] = password

	return options
}

// Extract credentials from response headers
pqFetch.extractCredentials = function (response) {
	return {
		key: response.headers.get('X-Cred-Key'),
		token: response.headers.get('X-Cred-Token'),
		timeout: response.headers.get('X-Cred-Timeout')
	}
}

export default pqFetch
